import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { StoreRoutingModule } from './store-routing.module';
import { MatCardModule } from '@angular/material/card';
import { CrudModule } from '../../helpers/crud/crud.module';
import { GoogleMapsModule } from '@angular/google-maps';
import { ScreenService } from './services/screen.service';
import { MapComponent } from './map/map.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MapItemComponent } from './map-item/map-item.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SeeSelectedScreenComponent } from './see-selected-screen/see-selected-screen.component';
import { CartComponent } from './cart/cart.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PaymentComponent } from './payment/payment.component';
import {
    StripeElementsDirective,
    StripePaymentElementComponent,
} from 'ngx-stripe';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PayConfirmComponent } from './pay-confirm/pay-confirm.component';
import { BaseChartDirective } from 'ng2-charts';
import { SpotComponent } from './spot/spot.component';
import { MatRippleModule } from '@angular/material/core';


@NgModule({
    declarations: [
        MapComponent,
        MapItemComponent,
        SeeSelectedScreenComponent,
        CartComponent,
        PaymentComponent,
        PayConfirmComponent,
        SpotComponent
    ],
    imports: [
        CommonModule,
        StoreRoutingModule,
        MatCardModule,
        GoogleMapsModule,
        MatIconModule,
        MatButtonModule,
        CrudModule,
        ReactiveFormsModule,
        StripeElementsDirective,
        StripePaymentElementComponent,
        InfiniteScrollModule,
        BaseChartDirective,
        MatRippleModule
    ],
    providers: [ScreenService, DatePipe],
    exports: [
        MapItemComponent
    ]
})
export class StoreModule { }

